import IconButton from '@/components/view/atoms/button/IconButton'
import { IconType } from '@/components/view/atoms/icon/Icon'
import Text from '@/components/view/atoms/text/Text'

interface Props {
  text: string
  onClickClose(): void
}

const ModalHeader = ({ text, onClickClose }: Props) => {
  return (
    <>
      <div className='bg-surface-tertiary flex items-center justify-between gap-x-4 rounded-t-2xl px-4 py-2'>
        <Text size={14} weight={'bold'}>
          {text}
        </Text>
        <IconButton type={IconType.CLOSE} color={'secondary'} onClick={onClickClose} />
      </div>
    </>
  )
}

export default ModalHeader
